
import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box, Text, Flex, Switch } from '@chakra-ui/react';
import { useField, useFormikContext } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';

const NumberBlockBillField = ({ darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [field, meta] = useField('bill');
    const { setFieldValue, values } = useFormikContext();
    const error = meta.error;
    const showError = meta.touched;
    return (
        <FormControl sx={{ margin: '0 !important' }} isInvalid={!!error && showError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Bill <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Toggle whether this block is billed.
                    </Text>
                </Box>
                <Flex flex="1" minWidth="250px" alignItems="center" justifyContent="flex-start">
                    <Switch
                        id="bill"
                        name="bill"
                        isChecked={values.bill}
                        onChange={e => setFieldValue('bill', e.target.checked)}
                        mr={3}
                    />
                       {isHovered && (
                    <FieldToolTip
                        label="Toggle billing for this block."
                        ariaLabel="number-block-bill-tip"
                        left="25px"
                        top="-4px"
                    />
                )}
                    {showError && (
                        <Text color="red.500" fontSize="xs" ml={3} textAlign="right">
                            {error}
                        </Text>
                    )}
                </Flex>
             
            </Stack>
        </FormControl>
    );
};

export default NumberBlockBillField;
